import Box from '@material-ui/core/Box';
import styled from 'styled-components';

type SVGStyledProps = {
  active: boolean;
};
export const SVGStyled = styled.div<SVGStyledProps>`
  svg path,
  svg rect {
    fill: ${({ active, theme }) => active && theme.colors.malibu};
  }

  margin: auto;
  margin-right: 10px;
`;

export const GroupListButton = styled.div`
  border: 2px solid ${(props) => props.theme.colors.solitude};
  padding: 10px !important;

  .menu-text {
    flex-wrap: wrap;
  }

  .header {
    flex: 0 1 100%;
    font-weight: 600;
    color: ${(props) => props.theme.colors.kashmirBlue};
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .header-active {
    color: ${(props) => props.theme.colors.malibu};
  }

  .sub-header {
    color: ${(props) => props.theme.colors.ghost};
    /* font-size: 13px; */
    font-weight: 500;
  }

  @media screen and (max-width: 768px) {
    .header {
      font-size: 10px;
    }
    .sub-header {
      font-size: 9px;
    }
  }
`;

export const EntityListButton = styled.div`
  padding: 10px 5px !important;

  .menu-text {
    flex-wrap: wrap;
    height: fit-content;
    margin: auto;
  }

  .header {
    flex: 0 1 100%;
    /* font-size: 14px; */
    font-weight: 600;
    color: ${(props) => props.theme.colors.kashmirBlue};
  }

  .sub-header {
    color: ${(props) => props.theme.colors.ghost};
    /* font-size: 13px; */
    font-weight: 500;
  }

  @media screen and (max-width: 768px) {
    .header {
      font-size: 10px;
    }
    .sub-header {
      font-size: 9px;
    }
  }
`;

export const FormListButton = styled.div`
  padding-left: 8px !important;
  padding-right: 8px !important;

  .menu-text {
    /* font-size: 13px !important; */
    font-weight: 400 !important;
    color: ${(props) => props.theme.colors.kashmirBlue} !important;
  }

  .menu-arrow {
    color: ${(props) => props.theme.colors.kashmirBlue} !important;
  }

  .active {
    font-weight: 500 !important;
    color: ${(props) => props.theme.colors.malibu} !important;
  }
`;

export const SubformListButton = styled.div`
  padding-left: 8px !important;

  .menu-text {
    /* font-size: 13px !important; */
    font-weight: 400 !important;
    color: ${(props) => props.theme.colors.kashmirBlue} !important;
  }

  .active {
    font-weight: 500 !important;
    color: ${(props) => props.theme.colors.malibu} !important;
  }
`;

export const BoxSubmenu = styled(Box)`
  & .menu-submenu {
    &.has-collapse {
      display: flex;
    }
    @media screen and (max-width: 768px) {
      & .menu-subnav {
        & .menu-item.menu-item-active .menu-link {
          max-width: 168px;
          & .menu-text {
            max-width: 140px;
            white-space: normal;
            word-break: break-all;
          }
        }
      }
    }
  }
`;
